export default {
  title: 'Теперь вы можете закрыть эту страницу. Если у вас есть вопросы, пожалуйста, звоните нам по номеру',
  'call-rating': 'Оценка звонка',
  comment: {
    title: 'Пожалуйста, оставьте ваши комментарии:',
    placeholder: 'Напишите, если вам всё понравилось, ваши ожидания и впечатления',
    error: 'Если вы поставили плохую оценку, пожалуйста, объясните, что не так?',
    'send-btn': 'Отправить',
  },
  'accepted-message': 'Ваш отзыв принят. Спасибо, что воспользовались нашей службой доставки!',
}
